export default __webpack_public_path__ + "static/assets/3775b6e6875cee01d416204c3f111aa3.png";